import { BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import styles from "./SeniorTabletBanner.module.css";
import { localePath } from "../../i18n/config";

const SeniorTabletBanner = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.banner}>
        {/* TOP SECTION: Spans full width */}
        <div className={styles.topSection}>
          <h2 className={styles.title}>
            Senioritablettipalvelun avulla pidät helposti yhteyttä senioriin
          </h2>
          <p className={styles.subtitle}>
            Videopuhelut aukeavat haluttaessa automaattisesti ja tavoitat
            seniorin omalla puhelimellasi. Kuukausimaksulla saat kaiken!
          </p>
        </div>

        {/* BOTTOM SECTION: Split into two columns */}
        <div className={styles.containerColumns}>
          {/* LEFT: Price and Button */}
          <div className={styles.left}>
            <div className={styles.price}>
              Tablettipalvelu alkaen 41€/kk
            </div>
            <Link className={styles.button} to={localePath("osta", "senioritabletti")}>OSTA</Link>
          </div>

          {/* RIGHT: Feature List */}
          <div className={styles.right}>
            <ul className={styles.list}>
              <li>
                <BsCheckCircleFill className={styles.icon} />
                <span>Muokattu Samsung -tabletti ja kotinäkymä</span>
              </li>
              <li>
                <BsCheckCircleFill className={styles.icon} />
                <span>Liittymä, jalusta. Jatkuva it-tuki</span>
              </li>
              <li>
                <BsCheckCircleFill className={styles.icon} />
                <span>Videopuhelut myös ilman kosketusta Digihappy apilla</span>
              </li>
              <li>
                <BsCheckCircleFill className={styles.icon} />
                <span>Aktivoivaa tekemistä seniorille</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeniorTabletBanner;
